import classnames from 'classnames';
import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  numberContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.borderRadius.std,
    backgroundColor: theme.colors.blueMuted,
    width: theme.marginBase * 3,
    height: theme.marginBase * 3,
  },
  small: {
    width: theme.marginBase * 2.5,
    height: theme.marginBase * 2.5,
  },
  number: {
    textAlign: 'center',
    ...theme.fonts.label,
    color: theme.colors.blueAccessible,
  },
}));

interface Props {
  number: number;
  small?: boolean;
}

export const QuestionNumber = ({ number, small }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div
      className={classnames(classes.numberContainer, {
        [classes.small]: !!small,
      })}
    >
      <span className={classes.number}>{number}</span>
    </div>
  );
};
